import * as React from "react"
import { UserType } from "../../types/user"
import { getUserTypeByUrl, getUserTypeByUrlV2 } from "../../util/getUserTypeByUrl"

export const useLocalUserType = () => {
  const userTypeFromUrl = getUserTypeByUrlV2()

  const isModerator = React.useMemo(
    () => userTypeFromUrl === UserType.MODERATOR,
    [userTypeFromUrl]
  )

  const isAudience = React.useMemo(() => {
    return userTypeFromUrl === UserType?.AUDIENCE
  }, [userTypeFromUrl])

  const isBroadcaster = React.useMemo(() => {
    return userTypeFromUrl === UserType?.BROADCASTER
  }, [userTypeFromUrl])

  return { isAudience, isBroadcaster, isModerator }
}
